import { useContext } from 'react';
import { EventTrackingContext } from '../contexts/EventTrackingContext';

export function useEventTracker() {
  return useContext(EventTrackingContext);
}
